/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import * as React from 'react';
import { Button, Heading, Modal, Size } from '@vaisala/rockhopper-components';

import { useProject } from '../state/project';
import { ReconstructionParamForm } from './ReconstructionParamForm';

export const ReconstructionParamModal = ({ visible, onDismiss}: { visible: boolean; onDismiss: VoidFunction; }) => {

  const { reconstructionSettings, updateReconstructionSettings } = useProject();

  const [nSplit, setNSplit] = React.useState<number>(reconstructionSettings.n_split??1);
  const [maxDesync, setMaxDesync] = React.useState<number>(reconstructionSettings.max_desync??2.0);
  const [htFilter, setHtFilter] = React.useState<number>(reconstructionSettings.ht_filter??0);
  const [nSigma, setNSigma] = React.useState<number[]>(reconstructionSettings.n_sigma??[0, 0]);
  const [meFilter, setMEFilter] = React.useState<number>(reconstructionSettings.me_filter??0);
  const [valid, setValid] = React.useState<boolean>(false);

  const [displayErrors, setDisplayErrors] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (visible) {
      setNSplit(reconstructionSettings.n_split??1);
      setMaxDesync(reconstructionSettings.max_desync??2.0);
      setHtFilter(reconstructionSettings.ht_filter??0);
      setNSigma(reconstructionSettings.n_sigma??[0, 0]);
      setMEFilter(reconstructionSettings.me_filter??0);
    }
  }, [visible])

  const saveParams = async () => {

    setDisplayErrors(false);

    if(reconstructionSettings.max_desync !== maxDesync) // Only this field is used in monitoring page
      localStorage.setItem("reconstruction_configuration_changed", "true");

    updateReconstructionSettings({
      'n_split': nSplit,
      'max_desync': maxDesync,
      'ht_filter': htFilter,
      'n_sigma': nSigma,
      'me_filter': meFilter
    });

  }

  const onSelectClick = () => {
    if (valid){
      saveParams();
      onDismiss();
    }
    else {
      setDisplayErrors(true);
    }
  };

  return (
    <Modal onDismiss={onDismiss} isOpen={visible} width={Size.L} showCloseIcon>
      <Heading level={2} className="vai-margin-top-none">
        Advanced Reconstruction Settings
      </Heading>
      <ReconstructionParamForm
        displayErrors={displayErrors}
        nSplit={nSplit} setNSplit={setNSplit}
        nSigma={nSigma} setNSigma={setNSigma}
        maxDesync={maxDesync} setMaxDesync={setMaxDesync}
        htFilter={htFilter} setHtFilter={setHtFilter}
        meFilter={meFilter} setMEFilter={setMEFilter}
        valid={valid} setValid={setValid}
      />

      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
        <Button onClick={onSelectClick}>Save</Button>
        <Button onClick={onDismiss}>Cancel</Button>
      </div>
    </Modal>
  );
};
